import React from 'react';

import { useChannelActivity, useChannelActivitySocket } from '../../hooks';
import { ActivityRow } from './ActivityRow';

export const ActivityTimeline: React.FC<{ channelId: string }> = ({ channelId }) => {
  useChannelActivitySocket(channelId);
  const { data, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } = useChannelActivity(channelId);
  const items = data?.pages.flatMap((p) => p.items) ?? [];

  return (
    <div data-testid="cdash-activity-section">
      {isLoading ? (
        <div className="cdash-empty"><div className="cdash-empty-t">Carregando atividade…</div></div>
      ) : items.length === 0 ? (
        <div className="cdash-empty" data-testid="cdash-activity-empty">
          <div className="cdash-empty-t">Nenhuma atividade ainda</div>
          <div className="cdash-empty-d">Comentários, menções e variações de seguidores aparecem aqui após o sync ou em tempo real.</div>
        </div>
      ) : (
        <div>
          {items.map((a) => (
            <ActivityRow key={a.id} activity={a} />
          ))}
          {hasNextPage ? (
            <button
              className="cdash-act-more"
              onClick={() => void fetchNextPage()}
              disabled={isFetchingNextPage}
              data-testid="cdash-activity-more"
            >
              {isFetchingNextPage ? 'Carregando…' : 'Carregar mais'}
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
};
